// Empty strings are okay, so just casting it to `null`.
const url = process.env.REACT_APP_GRAPHQL_GATEWAY ?? null;

// Should be defined, otherwise throw FATAl error.
if (url === null) throw new Error('provided with nullable graphql gateway url');

export const envGraphqlGatewayUrl = url;
